import { Box, Grid } from "@mui/material";
import { Field, Form, useForm } from "react-final-form";
import Bouton from "../../../components/Button/Bouton";
import FormContainer from "../../../components/FormContainer";
import Select from "../../../components/select/Select";
import { AdministrateurBienDetail, Site } from "../../../services/Api/swagger";
import {
  construireListAdb,
  construireListSite,
  ISelectAdbSiteFormData,
  validateForm,
} from "./helpers";
import styles from "./style";
import { FormEventHandler } from "react";

interface Props {
  listAdb?: AdministrateurBienDetail[];
  listSite?: Site[];
  isFetching?: boolean;

  // onSelectAdb(idAdb: string): void;

  // onSelectSite(idSite: string): void;

  onSubmit: FormEventHandler<HTMLFormElement>;
  change: <F extends keyof ISelectAdbSiteFormData>(
    name: F,
    value?: ISelectAdbSiteFormData[F] | undefined
  ) => void;
}

function SelectAdbSiteForm({
  // onSelectAdb,
  // onSelectSite,
  onSubmit,
  listAdb,
  listSite,
  isFetching,
  change,
}: Props) {
  // const onChangeAdb = (idAdb: string) => {
  //   change("site", "");
  //   onSelectAdb(idAdb);
  // };

  // const onChangeSite = (idSite: string) => {
  //   onSelectSite(idSite);
  // };

  const listAdbsOptions = listAdb && construireListAdb(listAdb);
  const listSitesOptions = listSite && construireListSite(listSite);

  return (
    <Box
      component="form"
      onSubmit={onSubmit}
      noValidate
      className={"formContainer"}
      sx={styles}
    >
      <FormContainer>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            {listAdbsOptions && (
              <Field
                name="adb"
                component={Select}
                // onChange={onChangeAdb}
                options={listAdbsOptions}
                label="ADB à selectionner"
                required
              />
            )}
          </Grid>
          <Grid item xs={12}>
            {listSitesOptions && (
              <Field
                name="site"
                component={Select}
                // onChange={onChangeSite}
                options={listSitesOptions}
                label="Site de l'ADB"
                required
              />
            )}
          </Grid>
        </Grid>
      </FormContainer>
      <Grid container justifyContent="center">
        <Grid item>
          <Bouton
            fetching={isFetching}
            label="Valider"
            variant="contained"
            color="primary"
            size="medium"
            type="submit"
          />
        </Grid>
      </Grid>
    </Box>
  );
}

export default SelectAdbSiteForm;
